var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.8433 17.9418L18.6666 24.7651M18.6666 24.7651L25.4899 17.9418M18.6666 24.7651V9.07152C18.6666 6.69922 18.6666 5.51307 17.7275 4.18502C17.1036 3.30263 15.3071 2.21357 14.2362 2.06847C12.6244 1.8501 12.0123 2.16939 10.7882 2.80798C5.33278 5.65379 1.6084 11.3629 1.6084 17.9418C1.6084 27.3628 9.24562 35 18.6666 35C28.0876 35 35.7248 27.3628 35.7248 17.9418C35.7248 11.6278 32.2944 6.11511 27.1957 3.16566",
    stroke: "#FCAF33",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownload);
export default __webpack_public_path__ + "static/media/circle-download.b3a68dd92c217149d6b0116f25967f1d.svg";
export { ForwardRef as ReactComponent };